import { getTranslateByScope } from '../../../../../services';

export const translate = getTranslateByScope('ui.layouts.StackDetail');
